import React, { useState } from 'react';
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from '@material-ui/icons/Delete';
import makeStyles from "@material-ui/core/styles/makeStyles";
import TextField from "@material-ui/core/TextField";
import AddIcon from "@material-ui/icons/Add";
import GetAppIcon from '@material-ui/icons/GetApp';
import PublishIcon from '@material-ui/icons/Publish';
import {
  Paper,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from '@material-ui/core'
import { CSVLink } from "react-csv";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: 200,
      marginTop: theme.spacing(3),
      overflowX: "auto"
    },
  },
  'one-line-fields': {
    display: 'flex',
    alignItems: 'center'
  },
  rootpaper: {
    width: 600,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    overflowX: "auto"
  },
  table: {
    width: 600
  },
}));

const StrappingTable = ({ tankName, table, change = () => { }, remove = () => { }, csvHeaders, replaceTable, csvFileName, csvReportData, viewMode = false }) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const [uploadResult, setUploadResult] = useState();
  const csvLink = React.useRef();

  const [fluidHeight, setFluidHeight] = useState('');
  const [fluidVolume, setFluidVolume] = useState('');
  const handleLevelVolumeChange = () => {
    if (!fluidHeight || !fluidVolume) {
      return;
    }
    change([fluidHeight, fluidVolume]);
    setFluidHeight('');
    setFluidVolume('');
  };
  const deleteRow = (index) => {
    table.splice(index, 1);
    remove(table);
  };

  const downloadCSVReport = (event) => {
    console.log("Downloading CSV for branch data...");
    csvLink.current.link.click();
  };

  const onFileUpload = (event) => {
    // Create an object of formData 
    let file = event.target.files[0];

    if (window.FileReader) {
      var reader = new FileReader();
      reader.onload = function (r) {
        setUploadResult(r.target.result);
        var result = r.target.result;

        result = result.replace(/['"\r]+/g, '');
        result = result.split("\n");
        var header = result[0].split(",");
        if (header[0] === csvHeaders[0].label && header[1] === csvHeaders[1].label) {
          if (result.length > 101) {
            alert(t("fileExceedsLimit"));
          }
          else {
            var row = [];
            var rowObj = {};
            var newTable = [];

            for (var i = 1; i < result.length; i++) {
              row = result[i].split(",");
              if(!isNaN(parseInt(row[0])) && !isNaN(parseInt(row[1])))
              {
                rowObj[csvHeaders[0].key] = parseInt(row[0]);
                rowObj[csvHeaders[1].key] = parseInt(row[1]);
                console.log(rowObj);
                newTable.push(JSON.parse(JSON.stringify(rowObj)));
              }
            }
            // Ensure the first entry is 0,0 point
            if ((newTable !== undefined || newTable.length !== 0)) {
              if (newTable[0].height !== 0 || newTable[0].volume !== 0) {
                newTable.unshift({ height: 0, volume: 0 });
              }
            }
            replaceTable(newTable);
          }
        }
        else {
          alert(t("fileFormatIsIncorrect"));
          console.log(header);
        }
      }

      reader.readAsText(file);
    }
    else {
      alert(t("sorryYourBrowserDoesntSupport"));
    }
  };

  return (
    <div className={classes.root}>

      <CSVLink
        data={csvReportData}
        filename={csvFileName}
        className='hidden'
        ref={csvLink}
        target='_blank' />

      <div className={classes['one-line-fields']}>
        {viewMode && <Typography>{t("strappingTable")}</Typography>}
        {!viewMode && <TextField type="number" label={t("fluidHeight")} helperText={t("required")}
          value={fluidHeight} onChange={(e) => setFluidHeight(e.target.value)} />}

        {!viewMode && <TextField
          type="number"
          label={t("fluidVolume")}
          helperText={t("required")}
          value={fluidVolume} onChange={(e) => setFluidVolume(e.target.value)}
        />}

        {!viewMode && <Tooltip title={t("addRow")}>
          <IconButton aria-label={t("add")} onClick={handleLevelVolumeChange}>
            <AddIcon />
          </IconButton>
        </Tooltip>}
        <Tooltip title={t("download")}>
          <IconButton aria-label="download-table" variant="contained" onClick={() => downloadCSVReport()}>
            <GetAppIcon />
          </IconButton>
        </Tooltip>

        <input accept=".csv" id="icon-button-file"
          type="file" style={{ display: 'none' }} onChange={e => onFileUpload(e)} />

        <label htmlFor="icon-button-file">
          {!viewMode && <Tooltip title={t("upload")}>
            <IconButton aria-label="upload picture"
              component="span">
              <PublishIcon />
            </IconButton>
          </Tooltip>}
        </label>
      </div>

      {(table.length > 0) && <Paper className={classes.rootpaper}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>{t("height")}</TableCell>
              <TableCell>{t("volume")}</TableCell>
              {!viewMode && <TableCell></TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {table.map((item, index) => {
              return (
                <TableRow key={`row-${index}`}>
                  <TableCell>{item.height}</TableCell>
                  <TableCell>{item.volume}</TableCell>
                  {!viewMode && <TableCell>
                    <IconButton edge="end" aria-label="delete" onClick={() => deleteRow(index)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Paper>}
    </div>
  );
};

export default StrappingTable;
